import "../styles/contactinfo.css";
import fbLogo from "../assets/facebook-logo.svg";
import LnLogo from "../assets/linkedin-logo.svg";
import logo from "../assets/dcbiomedical-logo.png";
import { usePublicInfo } from "../hooks/use-public-info";

function ContactInfo() {
    const { info, loading } = usePublicInfo();
    if (loading || !info) return <p>Loading...</p>;
    const stripPhone = (p) => p.replace(/[^\d+]/g, "");
    return (
        <footer className="ContactInfo">
            <div className="ContactInfo-Contents">
                <img className="dcbiomedical-logo" src={logo} alt="dcbiomedical-logo" />
                <div className="ContactInfo-Left">      
                    <p className="Contact-Us-Company-Name">
                        DC Biomedical Services LLC
                    </p>

                    <p className="Contact-Us-Address">
                    <a
                        href="https://www.google.com/maps/search/?api=1&query=33+Sangra+Court+Unit+1+Streamwood+IL+60107"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        33 Sangra Court Unit 1 <br />
                        Streamwood, IL 60107
                    </a>
                    </p>
                    </div>
                    <div className="ContactInfo-Middle">
                        <p className="Contact-Info-Contact-Contents">
                            Phone: <a href={`tel:${stripPhone(info.phone)}`}>(847) 338-4950</a> <br />
                            Toll-Free: <a href={`tel:${stripPhone(info.toll)}`}>(877) 727-4715</a> <br />
                            Fax: <a href={`tel:${stripPhone(info.fax)}`}>(630) 289-8815</a> <br />
                            Email: <a href={`mailto:${info.email}`}>{info.email}</a>
                        </p>
                </div>
                <div className="ContactInfo-Right"> 
                    <a href={info.socials.facebook} target="_blank" rel="noopener noreferrer">
                    <img src={fbLogo} alt="Facebook" />
                    </a>
                    <a href={info.socials.linkedin} target="_blank" rel="noopener noreferrer">
                    <img src={LnLogo} alt="Linkedin" />
                    </a>
                </div>
            </div>
        </footer>
  );
}

export default ContactInfo;